<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated" v-if="newsList">
      <div class="breadcrumb_con flex-display">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item
            ><router-link to="/Home">{{
              $t("common.Glang")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $t("top.News") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <img class="header_img" v-if="head_img" :src="img_head_url+head_img.src" />
      <div class="body_con">
        <div class="news_con">
          <div
            class="news_item"
            v-for="(item, index) in newsList"
            :key="'news' + index"
          >
            <router-link :to="'/NewDetail?id=' + item.id"
              ><el-row :gutter="12">
                <el-col :span="8">
                  <div class="news_pic">
                    <img class="bg" src="../assets/img/news_bg.png" alt="" />
                    <img
                      class="img"
                      v-if="item.src"
                     :src="img_head_url + item.src"
                      :alt="item.title"
                    />
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="news_box">
                    <p class="news_title">
                      {{ item.title }}
                    </p>
                    <p class="news_time">{{item.create_time}}</p>
                    <p class="news_content">
                      {{ item.sub_title }}
                    </p>
                    <div class="news_detail flex-display">
                      <!-- <router-link to="/About" class="more"
                        ><i class="el-icon-arrow-right"></i
                        >{{ $t("common.ReadMore") }}</router-link -->
                      <div class="more">
                        <i class="el-icon-arrow-right"></i
                        >{{ $t("common.ReadMore") }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row></router-link
            >
          </div>
          <el-pagination
            style="margin: 20px 0; text-align: center"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="limit"
            :total="count"
            background
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      loading: false,
      newsList: [],
      page: 1,
      count: 0,
      limit: 6,
      img_head_url: '',
      head_img: '',
      lang: localStorage.lang || 'cn'
    }
  },
  created () {
    this.getNewsList()
  },
  methods: {
    getNewsList () {
      var that = this
      var json = {
        lang: that.lang,
        page: that.page
      }
      var url = '/api/get_news_list'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.count = res.data.count
          that.page = res.data.page
          that.newsList = res.data.news_list
          that.img_head_url = res.img_head_url
          that.head_img = res.data.head_img
        }
      })
    },
    handleCurrentChange (val) {
      this.page = val
      this.getNewsList()
    }
  },
  mounted () {}
}
</script>
<style lang="less" scoped>
.news_con {
  width: 1200px;
  margin: 100px auto 60px;
  position: relative;
}
.news_item {
  display: block;
  width: 100%;
  margin-bottom: 60px;
  position: relative;
}
.news_item .news_pic {
  overflow: hidden;
  font-size: 0;
  position: relative;
  width: 100%;
}
.news_item .news_pic .bg {
  width: 100%;
  transition: all 0.3s;
}
.news_item .news_pic .img {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  max-width: 100%;
}
.news_item .news_pic:hover .img {
  transform: scale(1.1);
}
.news_box {
  margin-left: 60px;
  text-align: left;
}
.news_box .news_title {
  color: #333;
  margin: 0 0 18px 0;
  height: 30px;
  line-height: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 22px;
}
.news_box .news_content {
  color: #333;
  margin: 18px 0;
  height: 30px;
  line-height: 30px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
}
.news_box .more {
  color: #fff;
  background-color: #3c427c;
  border: 1px solid #3c427c;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s;
}
.news_box .more i {
  margin-right: 5px;
}
.news_box .more:hover {
  color: #3c427c;
  background-color: #fff;
  border: 1px solid #3c427c;
}
.news_box .news_time {
  font-size: 16px;
  color: #303133;
}
</style>
